import apiSubmitLink from '../../utils/link/linkApi';

export const LINK_SUCCESS = 'LINK_SUCCESS';
export const LINK_INITIATED = 'LINK_INITIATED';

const initiatedActionIndentifiers = [];

export const onCompleteLink = (
    apiRequestData,
    actionCompletedTime,
    actionIdentifier
) => dispatch => {
    if (
        initiatedActionIndentifiers.find(identifier => identifier === apiRequestData.id)
    ) {
        return;
    }

    dispatch({
        type: LINK_INITIATED,
        payload: { actionIdentifier }
    });

    apiSubmitLink(apiRequestData, actionCompletedTime).then(data => {
        dispatch({
            type: LINK_SUCCESS,
            payload: { ...data, actionIdentifier }
        });
    });

    initiatedActionIndentifiers.push(apiRequestData.id);

    return true;
};



// WEBPACK FOOTER //
// ./src/containers/Link/actions.js